import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { UserPreferenceActions } from '../actions/user-preference.actions';
import { ErrorModel } from '@shared/models/shared/error.model';
import { UserPreferenceResultType } from '@shared/types/user-preference.types';
import { UserPreferenceDataApiService } from '../../../services/user-preferences-redux/user-preferences-data-api.service';

@Injectable()
export class UserPreferenceEffects {
  getInbondLayoutPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferenceActions.getInbondLayoutPreference),
      exhaustMap(({ componentName }) => {
        return this.userPreferenceDataApiService.getUserPreference(componentName).pipe(
          map((preferences: UserPreferenceResultType | undefined) =>
            UserPreferenceActions.getInbondLayoutPreferenceSuccess({ componentName, preferences })
          ),
          catchError((errors: ErrorModel[]) =>
            of(UserPreferenceActions.getInbondLayoutPreferenceFail({ componentName, errors }))
          )
        );
      })
    )
  );

  updateInbondLayoutPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferenceActions.updateInbondLayoutPreference),
      exhaustMap(({ componentName, preferences }) => {
        return this.userPreferenceDataApiService.updateUserPreference(componentName, preferences).pipe(
          map(() => UserPreferenceActions.updateInbondLayoutPreferenceSuccess({ componentName, preferences })),
          catchError((errors: ErrorModel[]) =>
            of(UserPreferenceActions.updateInbondLayoutPreferenceFail({ componentName, errors }))
          )
        );
      })
    )
  );

  getRedeliveryLayoutPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferenceActions.getRedeliveryLayoutPreference),
      exhaustMap(({ componentName }) => {
        return this.userPreferenceDataApiService.getUserPreference(componentName).pipe(
          map((preferences: UserPreferenceResultType | undefined) =>
            UserPreferenceActions.getRedeliveryLayoutPreferenceSuccess({ componentName, preferences })
          ),
          catchError((errors: ErrorModel[]) =>
            of(UserPreferenceActions.getRedeliveryLayoutPreferenceFail({ componentName, errors }))
          )
        );
      })
    )
  );

  updateRedeliveryLayoutPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferenceActions.updateRedeliveryLayoutPreference),
      exhaustMap(({ componentName, preferences }) => {
        return this.userPreferenceDataApiService.updateUserPreference(componentName, preferences).pipe(
          map(() => UserPreferenceActions.updateRedeliveryLayoutPreferenceSuccess({ componentName, preferences })),
          catchError((errors: ErrorModel[]) =>
            of(UserPreferenceActions.updateRedeliveryLayoutPreferenceFail({ componentName, errors }))
          )
        );
      })
    )
  );

  constructor(private actions$: Actions, private userPreferenceDataApiService: UserPreferenceDataApiService) {}
}
